<template>
  <MensagemErro v-if="erro" :titulo="titulo" :classe="nomeImposto" />
  <LoadingResultado v-else-if="ativarLoading" :titulo="titulo" :classe="nomeImposto" borderTop />
  <MensagemIpi v-else-if="regra == 0" :titulo="titulo" :classe="nomeImposto" />
  <MensagemIcmsInterno v-else-if="icmsAliquota == null" :titulo="titulo" :classe="nomeImposto" />
  <MultiplosSemResultado v-else-if="!exibeImposto" :titulo="titulo" :classe="nomeImposto" />
  <div v-else-if="imposto">
    <h2 class="nome-impressao">ICMS CARGA LÍQUIDA</h2>
    <QuadroAlerta
      v-if="imposto.perguntas.length != 0"
      :classe="nomeImposto"
      :dadosForm="dadosForm"
      @exibeAlerta="alerta => (exibeAlerta = alerta)"
    />
    <QuadroPrincipal
      :borderTop="imposto.perguntas.length == 0 || !exibeAlerta"
      :titulo="'SEGMENTO'"
      :classe="imposto.classe"
    >
      <div v-if="imposto.perguntas.length == 0">
        <ImpostoSemResultado :titulo="imposto.nome" />
      </div>
      <div v-else>
        <PerguntasIcmsCargaLiquida
          :key="getRenderKey"
          :imposto="imposto"
          :edita="edita"
          :segmentoSelecionado="segmentoSelecionado"
          :seleciona="seleciona"
          :selecionouSegmento="selecionouSegmento"
          :loading="loading"
        />
      </div>
    </QuadroPrincipal>
    <!-- <LoadingResultado v-if="ativarLoadingSecundario" :titulo="''" :classe="nomeImposto" /> -->
    <QuadroIcms
      v-if="regrasQuadroIcms"
      :id="id"
      :imposto="imposto"
      :edita="editaIcms"
      :seleciona="selecionaIcms"
      :selecionado="icmsSelecionado"
      :selecionouIcms="selecionouIcms"
      :loading="loading"
      :reduzAliquota="reduzAliquota"
      :classe="nomeImposto"
    />
    <FundoIcms
      v-if="!ativarLoadingSecundario && selecionouIcms"
      :classe="imposto.classe"
      :fundo="imposto.fundo"
      :seleciona="selecionaFundo"
      :fundoSelecionado="fundoSelecionado"
      :selecionouFundo="selecionouFundo"
      :edita="editaFundo"
      :loading="loading"
      :aliquotaEfetivaSelecionada="aliquotaEfetivaSelecionada"
    />
    <!-- <LoadingResultado v-if="ativarLoadingTerciario" :titulo="''" :classe="nomeImposto" /> -->
    <BeneficiosIcms
      v-if="
        (!!imposto.beneficio.length || alteracaoImportacao) &&
          selecionouIcms &&
          !ativarLoadingTerciario &&
          icmsSelecionado.label != 'Não Incidência'
      "
      :key="forceRerenderKeyBeneficios"
      :beneficios="imposto.beneficio"
      :beneficioSelecionado="beneficioSelecionado"
      :classe="imposto.classe"
      :seleciona="selecionaBeneficio"
      :selecionouBeneficio="selecionouBeneficio"
      :loading="loading"
    />
    <!-- <LoadingResultado v-if="ativarLoadingQuaternario" :titulo="''" :classe="nomeImposto" /> -->
    <QuadroSegmentoCargaLiquida
      v-if="
        !!resultadoSegmentoCargaLiquida &&
          selecionouIcms &&
          !ativarLoadingTerciario &&
          !ativarLoadingQuaternario &&
          !exibeIsencao
      "
      :classe="imposto.classe"
      :segmento="resultadoSegmentoCargaLiquida"
      :seleciona="selecionaSegmento"
      :segmentoSelecionado="segundoSegmentoSelecionado"
      :selecionouSegmento="selecionouSegundoSegmento"
      :edita="editaSegmento"
      :loading="loading"
    />
    <ResultadoCargaLiquida
      v-if="
        (resultadoCargaLiquida && !ativarLoadingQuinario && selecionouSegundoSegmento) ||
          exibeIsencao
      "
      :isencao="exibeIsencao"
      :dados="resultadoCargaLiquida"
      :cargaLiquidaSelecionada="cargaLiquidaSelecionada"
      :selecionouCargaLiquida="selecionouCargaLiquida"
      :seleciona="selecionaCargaLiquida"
      :edita="editaCargaLiquida"
      :classe="imposto.classe"
    />
    <LoadingResultado v-if="loading" :titulo="''" :classe="nomeImposto" />
  </div>
</template>

<script>
import rotaBufferMixin from "@/mixins/rotaBufferMixin";

import BeneficiosIcms from "@/components/BeneficiosIcms/BeneficiosIcms.vue";
import FundoIcms from "@/components/FundoIcms/FundoIcms.vue";
import ImpostoSemResultado from "@/components/ImpostoSemResultado/ImpostoSemResultado.vue";
import LoadingResultado from "@/components/LoadingResultado/LoadingResultado.vue";
import MensagemIcmsInterno from "@/components/MensagemIcmsInterno/MensagemIcmsInterno.vue";
import MensagemIpi from "@/components/MensagemIpi/MensagemIpi.vue";
import MensagemErro from "@/components/MensagemErro/MensagemErro.vue";
import MultiplosSemResultado from "@/components/ImpostoSemResultado/MultiplosSemResultado.vue";
import PerguntasIcmsCargaLiquida from "@/components/PerguntasIcmsCargaLiquida/PerguntasIcmsCargaLiquida.vue";
import QuadroAlerta from "@/components/QuadroAlerta/QuadroAlerta.vue";
import QuadroIcms from "@/components/QuadroIcms/QuadroIcms.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import QuadroSegmentoCargaLiquida from "@/components/QuadroSegmentoCargaLiquida/QuadroSegmentoCargaLiquida.vue";
import ResultadoCargaLiquida from "@/components/ResultadoCargaLiquida/ResultadoCargaLiquida.vue";

import { mapActions, mapGetters } from "vuex";
export default {
  name: "IcmsCargaLiquida",

  mixins: [rotaBufferMixin],

  props: {
    id: String | Number,
    buscarImposto: Function,
    tributoAtivo: String,
    exibeImposto: Boolean,
    limparImpostos: Boolean
    // dadosForm: Array | Object,
  },

  inject: ["alteracaoImportacao"],

  components: {
    BeneficiosIcms,
    FundoIcms,
    ImpostoSemResultado,
    LoadingResultado,
    MensagemIcmsInterno,
    MensagemIpi,
    MensagemErro,
    MultiplosSemResultado,
    QuadroIcms,
    QuadroPrincipal,
    QuadroSegmentoCargaLiquida,
    PerguntasIcmsCargaLiquida,
    ResultadoCargaLiquida,
    QuadroAlerta
  },

  data() {
    return {
      exibeAlerta: false,
      titulo: "ICMS CARGA LÍQUIDA",
      ativarLoading: false,
      ativarLoadingSecundario: false,
      ativarLoadingTerciario: false,
      ativarLoadingQuaternario: false,
      ativarLoadingQuinario: false,
      beneficios: null,
      beneficioClasse: null,
      exibeIsencao: false,
      forceRerenderKeyBeneficios: 0,
      cargaTributariaEfetiva: 0,
      imposto: null,
      icms: null,
      nomeImposto: "carga_liquida",
      resultadoSegmentoCargaLiquida: null,
      segmentoSelecionado: {},
      icmsSelecionado: {},
      fundoSelecionado: {},
      beneficioSelecionado: {},
      segundoSegmentoSelecionado: {},
      cargaLiquidaSelecionada: {},
      resultadoCargaLiquida: null,
      selecionouSegmento: false,
      selecionouIcms: false,
      selecionouFundo: false,
      selecionouBeneficio: false,
      selecionouSegundoSegmento: false,
      selecionouCargaLiquida: false,
      requerIcms: true,
      requerFundo: true,
      requerSegundoSegmento: true,
      requerCargaLiquida: true,
      dadosForm: {},
      regra: 0,
      icmsAliquota: null,
      icmsAliquotaBackup: null,
      reduzAliquota: 0,
      erro: false,
      isencaoCargaLiquida: {
        base: [
          {
            label: "Inaplicabilidade da Carga Líquida",
            texto_inaplicabilidade:
              "Não se aplica o regime de Carga Líquida, caso esteja sujeito a Isenção ou Não Incidência do ICMS.",
            id_imposto: 100
          }
        ]
      }
    };
  },

  created() {
    this.setSelecao({
      selecao: { selecionouIcmsCargaLiquida: this.selecionouIcmsCargaLiquida },
      id: this.id
    });
  },

  updated() {
    if (this.selecionouIcmsCargaLiquida) {
      this.setLog(this.impressaoLog);
    }
  },

  watch: {
    async tributoAtivo(newValue) {
      this.erro = false;
      // PUXA VALOR DE REGRA DO IPI QUANDO TROCA DE ABA
      this.regra = this.getDadosForm[this.id].regra;
      // PUXA VALOR DE ALÍQUOTA DO ICMS QUANDO TROCA DE ABA
      this.icmsAliquota = this.getDadosForm[this.id].aliquotaIcmsSelecionada;

      // VERIFICA SE HOUVE TROCA DE ALÍQUOTA DO ICMS INTERNO
      if (this.icmsAliquota != this.icmsAliquotaBackup) {
        this.imposto = null;
      }

      if (
        newValue == this.nomeImposto &&
        this.regra != 0 &&
        !this.imposto &&
        !this.ativarLoading &&
        this.icmsAliquota != null &&
        this.exibeImposto
      ) {
        // ATUALIZA O BACKUP DA ALIQUOTA PARA FUTURAS VERIFICAÇÕES
        this.icmsAliquotaBackup = this.icmsAliquota;

        this.dadosForm = { ...this.getDadosForm[this.id] };
        this.ativarLoading = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            [this.imposto] = await this.buscarImposto({
              imposto: this.nomeImposto,
              idCenario: this.id
            });
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoading = false;
            }
          }
        }
        this.ativarLoading = false;
      }
    },

    limparImpostos(newValue) {
      if (newValue) {
        this.imposto = null;
        this.edita();
      }
    },

    loading() {
      this.$emit("loading", this.loading);
    },

    selecionouIcmsCargaLiquida() {
      this.setSelecao({
        selecao: { selecionouIcmsCargaLiquida: this.selecionouIcmsCargaLiquida },
        id: this.id
      });
    }
  },

  computed: {
    ...mapGetters("form", ["getDadosForm"]),
    ...mapGetters("reRender", ["getRenderKey"]),

    loading() {
      if (
        this.ativarLoading ||
        this.ativarLoadingSecundario ||
        this.ativarLoadingTerciario ||
        this.ativarLoadingQuaternario ||
        this.ativarLoadingQuinario
      ) {
        return true;
      }
      return false;
    },

    regrasQuadroIcms: function() {
      return !!this.imposto.icms && !this.ativarLoadingSecundario && this.selecionouSegmento;
    },

    aliquotaEfetivaSelecionada() {
      if (this.selecionouIcms && this.selecionouFundo) {
        // CÁLCULO DE ALÍQUOTA EFETIVA BASEADO NA REGRA DO FUNDO
        if (this.fundoSelecionado.regra_fundo == 2) {
          this.reduzAliquota = this.fundoSelecionado.aliquota;
          return Number(this.icmsSelecionado.aliquota);
        } else {
          this.reduzAliquota = 0;
          return Number(this.icmsSelecionado.aliquota) + Number(this.fundoSelecionado.aliquota);
        }
        // FIM
      }
      this.reduzAliquota = 0;
      return null;
    },

    selecionouIcmsCargaLiquida() {
      const selecionou = [
        this.selecionouSegmento,
        !this.requerIcms || this.selecionouIcms,
        !this.requerFundo || this.selecionouFundo,
        !this.requerSegundoSegmento || this.selecionouSegundoSegmento,
        !this.requerCargaLiquida || this.selecionouCargaLiquida
      ];
      // DEBUG CONSOLE
      // console.log(selecionou);
      return !selecionou.filter(boolean => boolean == false).length;
    },

    impressaoLog() {
      let log = {
        logIcmsCargaLiquida: {
          perguntas: this.segmentoSelecionado,
          icms: this.icmsSelecionado,
          fundo: this.fundoSelecionado,
          beneficio: this.beneficioSelecionado,
          segmento: this.segundoSegmentoSelecionado,
          cargaLiquida: this.resultadoCargaLiquida
        }
      };
      return log;
    }
  },

  methods: {
    ...mapActions("tributosSelecionados", ["setSelecao"]),
    ...mapActions("logResultados", ["setLog"]),

    padronizaRequerimentosImpressao(boolean) {
      this.requerIcms = boolean;
      this.requerFundo = boolean;
      this.requerSegundoSegmento = boolean;
      this.requerCargaLiquida = boolean;
    },

    async seleciona(imposto) {
      this.segmentoSelecionado = imposto;
      this.selecionouSegmento = true;

      //AJUSTES PARA PAYLOAD
      this.dadosForm.id_cest = this.segmentoSelecionado.id_mapa;
      this.dadosForm.id_beneficio = null;
      this.dadosForm.id_beneficio_uf = null;
      //FIM
    },

    async selecionaIcms(imposto) {
      this.resultadoCargaLiquida = null;
      this.exibeIsencao = false;
      this.icmsSelecionado = imposto;
      this.selecionouIcms = true;

      // PAYLOAD
      this.dadosForm.base = false;
      this.dadosForm.id_previa = null;
      this.dadosForm.v_aliquota = this.icmsSelecionado.aliquota;
      this.dadosForm.id_beneficio = null;
      this.dadosForm.id_beneficio_uf = null;
      // FIM

      // BUSCA RESULTADO PARA IMPOSTO DO CARGA LÍQUIDA
      if (imposto.label != "Não Incidência") {
        this.ativarLoadingTerciario = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoSegmentoCargaLiquida = await this.chamadaRota(
              "Cenario/obterImpostoCargaLiquida",
              this.dadosForm
            );
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingTerciario = false;
            }
          }
        }
        this.ativarLoadingTerciario = false;
      } else {
        this.exibeIsencao = true;
        this.resultadoCargaLiquida = this.isencaoCargaLiquida;
        this.requerSegundoSegmento = false;
        this.selecionaCargaLiquida(this.resultadoCargaLiquida.base[0]);
      }
      this.requerIcms = this.imposto ? !!this.imposto.icms.length : true;
      this.requerFundo = this.imposto ? !!this.imposto.fundo.dados.length : true;
      this.requerSegundoSegmento = this.resultadoSegmentoCargaLiquida
        ? !!this.resultadoSegmentoCargaLiquida.dados.length
        : false;
      // FIM
    },

    selecionaFundo(imposto) {
      this.fundoSelecionado = imposto;
      this.selecionouFundo = true;
    },

    selecionaBeneficio(id) {
      this.exibeIsencao = false;
      this.beneficios = this.imposto.beneficio.map(beneficio => {
        if (beneficio.id_imposto == id) {
          this.beneficioSelecionado = beneficio.selecionado ? beneficio : {};
          this.selecionouBeneficio = beneficio.selecionado;
          this.beneficioClasse = beneficio.label;

          this.dadosForm.id_previa = null;
          this.dadosForm.base = false;
          this.dadosForm.id_beneficio = this.selecionouBeneficio
            ? beneficio.id_tributacao_geral
            : null;
          this.dadosForm.id_beneficio_uf = this.selecionouBeneficio
            ? beneficio.id_tributacao_uf
            : null;
        } else {
          beneficio.selecionado = false;
        }
        return beneficio;
      });
      this.editaSegmento();
      this.forceRerenderKeyBeneficios += 1;

      //CHAMA OU NÃO O CARGA LÍQUIDA QUANDO SELECIONADO BENEFÍCIO
      this.chamadaBeneficio();
    },

    async selecionaSegmento(imposto) {
      this.segundoSegmentoSelecionado = imposto;
      this.requerCargaLiquida = imposto.id_imposto == 100 ? false : true;
      this.selecionouSegundoSegmento = true;

      //PAYLOAD
      this.dadosForm.id_previa = imposto.id_imposto != 100 ? imposto.id_mapa : null;
      this.dadosForm.base = true;
      //FIM
      if (!this.ativarLoadingQuinario && imposto.id_imposto != 100) {
        this.ativarLoadingQuinario = true;
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoCargaLiquida = await this.chamadaRota(
              "Cenario/obterImpostoCargaLiquida",
              this.dadosForm
            );
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingQuinario = false;
            }
          }
        }
        this.ativarLoadingQuinario = false;
      }
    },
    async selecionaCargaLiquida(imposto) {
      this.cargaLiquidaSelecionada = imposto;
      this.selecionouCargaLiquida = true;
    },
    async chamadaBeneficio() {
      this.ativarLoadingQuaternario = true;
      if (this.selecionouBeneficio) {
        // CHAMA RESULTADO DO CARGA LÍQUIDA CASO NÃO SEJA BENEFÍCIO DE ISENÇÃO
        if (this.beneficioClasse != "Isenção") {
          let tentativas = 0;
          while (tentativas < 3) {
            try {
              this.resultadoSegmentoCargaLiquida = await this.chamadaRota(
                "Cenario/obterImpostoCargaLiquida",
                this.dadosForm
              );
              tentativas = 3;
            } catch (error) {
              tentativas++;
              console.error(`${tentativas}ª tentativa`);
              if (tentativas === 3) {
                console.error(error);
                this.erro = true;
              }
            }
          }
        } else {
          // SE FOR BENEFÍCIO DE ISENÇÃO MOSTRA ALERTA DO FRONT
          this.exibeIsencao = true;
          this.resultadoCargaLiquida = this.isencaoCargaLiquida;
          this.requerSegundoSegmento = false;
          this.selecionaCargaLiquida(this.resultadoCargaLiquida.base[0]);
        }
      } else {
        // REINICIA PAYLOAD
        this.dadosForm.base = false;
        this.dadosForm.id_previa = null;
        this.dadosForm.id_beneficio = null;
        this.dadosForm.id_beneficio_uf = null;
        // FIM
        // EXIBE RESULTADO SEM BENEFÍCIO
        let tentativas = 0;
        while (tentativas < 3) {
          try {
            this.resultadoSegmentoCargaLiquida = await this.chamadaRota(
              "Cenario/obterImpostoCargaLiquida",
              this.dadosForm
            );
            tentativas = 3;
          } catch (error) {
            tentativas++;
            console.error(`${tentativas}ª tentativa`);
            if (tentativas === 3) {
              console.error(error);
              this.erro = true;
              this.ativarLoadingQuaternario = false;
            }
          }
        }
      }
      this.ativarLoadingQuaternario = false;
    },

    edita() {
      this.segmentoSelecionado = {};
      this.selecionouSegmento = false;
      this.icms = null;

      this.editaIcms();
    },

    editaIcms() {
      this.icmsSelecionado = {};
      this.selecionouIcms = false;
      this.beneficios = null;
      this.reduzAliquota = 0;
      this.padronizaRequerimentosImpressao(true);
      this.editaFundo();
      this.editaSegmento();
      this.editaBeneficios();
    },

    editaFundo() {
      this.fundoSelecionado = null;
      this.selecionouFundo = false;
    },

    editaSegmento() {
      this.segundoSegmentoSelecionado = {};
      this.selecionouSegundoSegmento = false;
      this.resultadoCargaLiquida = null;
      this.requerSegundoSegmento = true;
      this.requerCargaLiquida = true;
      this.editaCargaLiquida();
    },

    editaBeneficios() {
      this.beneficioSelecionado = {};
      this.selecionouBeneficio = false;
      this.exibeIsencao = false;
      if (this.imposto && this.imposto.beneficio) {
        this.imposto.beneficio.map(beneficio => {
          beneficio.selecionado = false;
        });
      }
      this.editaSegmento();
    },
    async editaCargaLiquida() {
      this.cargaLiquidaSelecionada = {};
      this.selecionouCargaLiquida = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
